module.exports = __webpack_public_path__ + "static/media/imageprocessingquad.0b7eea99.vert";